import {getLogger} from 'loglevel';
import uikit from '../uikit';
import {SalesforceLiveAgent, EnableAjaxLoadHeader} from '../utilities/featureFlags';
import {LivePersonService} from '../services/LivePersonService';
import {createLiveAgent} from '../components/LiveAgent/LiveAgent';

const log = getLogger('LivePersonEntryPoint');

export class LivePersonEntryPoint extends uikit.EntryPoint {

  constructor() {
    super();
    this.livePersonService = LivePersonService.getInstance();
  }

  getLivePersonUrl() {
    // TODO: DT - we need a nicer way of getting LivePerson url
    if (!this.chatStatusUrlElement) {
      this.chatStatusUrlElement = document.querySelector('[data-chat-status]');
      if (this.chatStatusUrlElement) {
        this.livePersonService.statusImageSrc = this.chatStatusUrlElement.dataset.chatStatus;
      } else {
        log.debug('LivePerson: no status image url found');
      }
    }
    return this.livePersonService.statusImageSrc;
  }

  shouldRegister() {
    let shouldReg = super.shouldRegister();
    return EnableAjaxLoadHeader.isEnabled() || (shouldReg && !!this.getLivePersonUrl());
  }

  shouldInitialize() {
    let shouldInit = super.shouldInitialize();
    return shouldInit && !!this.getLivePersonUrl();
  }

  register() {
    uikit.components.register(createLiveAgent, { ajaxable: EnableAjaxLoadHeader.isEnabled(), priority: false })
  }
}



// WEBPACK FOOTER //
// ./assets/entryPoints/LivePersonEntryPoint.js